module.exports = __webpack_public_path__ + "static/media/org-chart.27662943.jpg";